import {ChangeDetectorRef, Component, ElementRef, EventEmitter, inject, Input, NgZone, OnChanges, Output, SimpleChanges} from '@angular/core';
import {ReportUserGenerated} from "../../../../core/model-store/models/report-user-generated";
import {waitForImages} from "../report-images";

@Component({
    selector: 'stamp-report',
    templateUrl: './stamp-report.component.html',
    styleUrls: ['./stamp-report.component.css'],
    standalone: false
})
export class StampReportComponent implements OnChanges {
  private readonly cdRef: ChangeDetectorRef = inject(ChangeDetectorRef);
  private readonly host: ElementRef<HTMLElement> = inject(ElementRef);
  private readonly ngZone: NgZone = inject(NgZone);

  @Input() reportTemplate: ReportUserGenerated;
  @Input() extractedArtifacts: any;
  @Input() viewOptionsCheckboxValues: any;
  @Input() preview: boolean = false;
  @Input() numColumnsInReport = 5;

  /** Emits when every image has loaded or failed, so the PDF can be printed. */
  @Output() imagesReady = new EventEmitter<void>();

  private latestImageWait = 0;

  isPromptsSelected() {
    return this.viewOptionsCheckboxValues.find((option) => option.key === 'vis_ledetekster')?.value;
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.hasOwnProperty('extractedArtifacts')) {
      this.waitForImagesThenEmit().then();
    }
  }

  private async waitForImagesThenEmit() {
    const wait = ++this.latestImageWait;
    // Let the thumbnails render before waiting for them.
    await Promise.resolve();
    this.cdRef.detectChanges();
    // Outside Angular, or every image event checks the whole report again,
    // so rendering time grew with the square of the number of objects.
    await this.ngZone.runOutsideAngular(() => waitForImages(this.host.nativeElement));
    if (wait === this.latestImageWait) {
      this.ngZone.run(() => this.imagesReady.emit());
    }
  }
}
